module.exports = __webpack_public_path__ + "media/images/icons/play-b89c9f65c44209290e59e6159c9b0e91.svg";